export default "__VITE_ASSET__13015a0b__"